/**
 * @generated SignedSource<<01a4508c47dec5c524225d4c06ba9736>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveKitMemberInput = {
  assetTag: any;
  clientMutationId?: string | null | undefined;
  kitId: string;
};
export type OpsKitPageRemoveMemberMutation$variables = {
  input: RemoveKitMemberInput;
};
export type OpsKitPageRemoveMemberMutation$data = {
  readonly removeKitMember: {
    readonly kit: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsKitPageRemoveMemberMutation = {
  response: OpsKitPageRemoveMemberMutation$data;
  variables: OpsKitPageRemoveMemberMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveKitMemberPayload",
    "kind": "LinkedField",
    "name": "removeKitMember",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "kit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsKitPageRemoveMemberMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsKitPageRemoveMemberMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a489499a2aac854c3f5c8ae597990b44",
    "id": null,
    "metadata": {},
    "name": "OpsKitPageRemoveMemberMutation",
    "operationKind": "mutation",
    "text": "mutation OpsKitPageRemoveMemberMutation(\n  $input: RemoveKitMemberInput!\n) {\n  removeKitMember(input: $input) {\n    kit {\n      id\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "233a7acb533da9b5f2f6ba02fd272bd5";

export default node;
